import 'bootstrap/js/src/modal'
import noop from '@hc-frontend/shared-assets/src/js/utils/fp/noop'
import storage from 'proxy-storage'
import updateLocationCopies from 'core/DOM/updateLocationCopies'
import buildControllerZipCounty from 'core/controllers/buildControllerZipCounty'
import buildControllerDOB from 'core/controllers/buildControllerDOB'
import buildControllerGender from 'core/controllers/buildControllerGender'
import buildControllerName from 'core/controllers/buildControllerName'
import buildControllerEmail from 'core/controllers/buildControllerEmail'
import buildControllerStartDate from 'core/controllers/buildControllerStartDate'
import buildControllerPeriod from 'core/controllers/buildControllerPeriod'
import buildControllerPhone from 'core/controllers/buildControllerPhone'
import { IS_SHORT_TERM } from 'core/constants/environment'
import handleMembers from './handleMembers'
import { MemberType } from '@hc-frontend/entities'

function locationUpdateHandler(handler = noop) {
  return ({ city, state, stateName, zip, county }) => {
    const hcStorage = storage.getItem('hc')

    hcStorage.location = {
      city: city,
      county: county,
      state: stateName,
      state_acronym: state,
      zip_code: zip
    }
    storage.setItem('hc', hcStorage)
    updateLocationCopies({ location: hcStorage.location })
    handler(hcStorage)
  }
}

function startDateUpdateHandler(handler = noop) {
  return ({ sDate }) => {
    if (sDate) {
      const hcStorage = storage.getItem('hc')
      hcStorage.sdate = sDate
      handler(hcStorage)
    }
  }
}

function getControllerZipCode(form, handler, county) {
  const zipCounty = buildControllerZipCounty({
    form,
    handleUpdateLocation: locationUpdateHandler(handler),
    county
  })

  return zipCounty
}

function initializerControllers(form, handleUpdateLocation) {
  const sdate = buildControllerStartDate({
    input: form.sdate,
    state: storage.getItem('hc'),
    handleUpdateDate: startDateUpdateHandler(handleUpdateLocation),
    callOnValidate: ({ valid }) => {
      if (valid && controllers.dob) {
        controllers.dob.validate()
      }
    }
  })

  function getSdate() {
    return sdate.getStatus().value
  }

  handleMembers.setGetSdate(getSdate)
  const controllers = {
    zip: getControllerZipCode(form, handleUpdateLocation),
    gender: buildControllerGender({ inputs: form.gender }),
    fname: buildControllerName({ input: form.fname }),
    lname: buildControllerName({ input: form.lname }),
    email: buildControllerEmail({ input: form.email }),
    phone: buildControllerPhone({ input: form.phone }),
    sdate,
    dob: buildControllerDOB({
      input: form.dob,
      typeMember: MemberType.Applicant,
      getSdate
    })
  }

  if (IS_SHORT_TERM) {
    controllers['period'] = buildControllerPeriod('period')
  }

  return controllers
}

export default initializerControllers
